import { Chip } from "@mui/material";

import { tempZoneBasedColor } from "~/lib/tempZone";
import { useGetFlaggedBinsQuery } from "~/redux/warehouse/autostoreGrid.hooks";
import { Guid } from "~/types/api";

export type GridFlaggedBinsChipProps = {
  grid: {
    autostoreGridId: Guid;
    temperatureZones: string[];
  };
  pollingInterval?: number;
};

export function GridFlaggedBinsChip({
  grid,
  pollingInterval
}: GridFlaggedBinsChipProps) {
  const {
    data: flaggedBinsData,
    isLoading,
    isUninitialized
  } = useGetFlaggedBinsQuery(
    {
      autostoreGridId: grid.autostoreGridId,
      workstationId: undefined
    },
    {
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
      skipPollingIfUnfocused: true,
      refetchOnReconnect: true,
      pollingInterval:
        pollingInterval && pollingInterval > 0 ? pollingInterval : undefined
    }
  );

  const binsToCleanCount = flaggedBinsData?.length ?? 0;
  const showLoadingState = isUninitialized || (isLoading && !flaggedBinsData);

  return (
    <Chip
      label={showLoadingState ? "..." : binsToCleanCount}
      size="small"
      sx={{
        fontWeight: "bold",
        bgcolor: tempZoneBasedColor(grid.temperatureZones[0]),
        color: "black"
      }}
    />
  );
}

export default GridFlaggedBinsChip;
